//
// Smooth Scroll to Anchor
// --------------------------------------------------

$('a.scrollto[href^="#"]').on('click', function(e) {

    // prevent default anchor click behavior
    e.preventDefault();

    // store hash
    var hash = this.hash;

    // Add sticky navigation height if screenwidth is MD or larger
    var stickyNavigationHeight = 0;
    if ($(window).width() > 991) {
        stickyNavigationHeight = 129;
    }

    // animate
    $('html, body').animate({
        scrollTop: $(hash).offset().top - stickyNavigationHeight
    }, 300, function(){

        // when done, add hash to url
        // (default click behaviour)
        window.location.hash = hash;
    });

});


// WEBPACK FOOTER //
// ./Private/JavaScript/Component/SmoothScroll.js